import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { UpdateVendorCitySlice } from "../../../../redux/features/VendorCityManagementSlice";
import ButtonSpinner from "../../../../common/Loader/ButtonSpinner";

const UpdateVendorCity = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const CityRef = useRef(null);
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.VendorCityManagement);

  const [dataForSend, setDataForSend] = useState({
    cityName: "",
    state: "",
    isActive: true,
  });

  useEffect(() => {
    setDataForSend({
      cityName: state?.cityName || "",
      state: state?.state || "",
      isActive: state?.isActive ?? true,
    });
  }, [state]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDataForSend((prev) => ({ ...prev, [name]: value }));
  };

  const handleToggle = () => {
    setDataForSend((prev) => ({ ...prev, isActive: !prev.isActive }));
  };

  const handleSubmit = () => {
    if (!dataForSend.cityName?.trim()?.length || !dataForSend.state?.trim()?.length) {
      toast.error("Please fill the details!");
      return;
    }

    dispatch(UpdateVendorCitySlice({ id: state?._id, data: dataForSend })).then((res) => {
      if (res?.payload?.data) {
        CityRef.current.click();
      }
    });
  };

  return (
    <div className="ModalBox">
      <div id="UpdateVendorCity" className="modal fade" aria-hidden="true" data-backdrop="static">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className="Category">
                <a
                  href="javascript:void(0);"
                  className="CloseModal"
                  data-dismiss="modal"
                  ref={CityRef}
                  onClick={() => navigate(-1)}
                >
                  ×
                </a>
                <h3>Edit Vendor City</h3>
                <div className="form-group">
                  <label>City Name</label>
                  <input
                    type="text"
                    name="cityName"
                    className="form-control"
                    placeholder="Enter City Name"
                    value={dataForSend?.cityName}
                    onChange={handleChange}
                  />
                </div>
                <div className="form-group">
                  <label>State</label>
                  <input
                    type="text"
                    name="state"
                    className="form-control"
                    placeholder="Enter State"
                    value={dataForSend?.state}
                    onChange={handleChange}
                  />
                </div>
                <div className="form-group">
                  <label>City Status</label>
                  <div
                    onClick={handleToggle}
                    style={{ display: "flex", alignItems: "center", gap: "10px", cursor: "pointer" }}
                  >
                    <div
                      style={{
                        width: "50px",
                        height: "26px",
                        borderRadius: "20px",
                        backgroundColor: dataForSend.isActive ? "#28a745" : "#ccc",
                        position: "relative",
                        transition: "0.3s",
                      }}
                    >
                      <div
                        style={{
                          width: "22px",
                          height: "22px",
                          borderRadius: "50%",
                          backgroundColor: "#fff",
                          position: "absolute",
                          top: "2px",
                          left: dataForSend.isActive ? "26px" : "2px",
                          transition: "0.3s",
                          boxShadow: "0 1px 3px rgba(0,0,0,0.3)",
                        }}
                      />
                    </div>
                    <span>{dataForSend.isActive ? "Active" : "Inactive"}</span>
                  </div>
                </div>
                <button disabled={loading} onClick={handleSubmit} className="Button">
                  {loading ? <ButtonSpinner /> : "Save"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdateVendorCity;
